import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "../UiStyle/AboutSection.css";
import SectionTitle from "../SectionTitle/SectionTitle";
import "./index.css";
import { useLoginModal } from "../../Context/LoginModalContext";

export default function AboutUs() {
  // Detect mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { openLoginModal } = useLoginModal();

  useEffect(() => {
    let timer;
    let shown = false;
    const LAST_SHOWN_KEY = "loginModalLastShown";
    const handleScroll = () => {
      const lastShown = localStorage.getItem(LAST_SHOWN_KEY);
      const now = Date.now();
      if (
        !shown &&
        (!lastShown || now - Number(lastShown) > 24 * 60 * 60 * 1000)
      ) {
        shown = true;
        timer = setTimeout(() => {
          openLoginModal();
          localStorage.setItem(LAST_SHOWN_KEY, now.toString());
        }, 5000);
        window.removeEventListener("scroll", handleScroll);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (timer) clearTimeout(timer);
    };
  }, [openLoginModal]);

  return (
    <section className="container about-section mb-40">
      <div className="row">
        <div className="col-md-5">
          <h4
            className="heading-title"
            style={
              isMobile
                ? { textAlign: "center", marginTop: 20 }
                : {}
            }
          >
            ABOUT US
          </h4>
          <div className="about-us-content">
              <p>
              At Chemist For All, our mission is simple: to provide our
              customers with safe and affordable healthcare. We provide generic
              medicines that are just as effective as brand-name drugs, at a
              fraction of the cost.
              </p>
              <p>
              We work with certified and well-established pharmaceutical
              manufacturers in India, ensuring every medicine we offer meets
              high standards of quality and safety. All products are thoroughly
              checked before being processed for shipping.
              </p>
              <p>
              Whether you need daily prescription medication or over-the-counter
              products, we’re here to help you get what you need — conveniently,
              securely, and without overpaying.
              </p>
              <div>
              <a href="/about"
                  style={{
                  backgroundColor: "#064ACB",
                  color: "white",
                  border: "none",
                  borderRadius: 10,
                  padding: 8,
                  }}
              >
                  Read More
              </a>
              </div>
          </div>
        </div>
        <div className="col-md-2"></div>
        <div className="col-md-5" style={{ marginTop: 20 }}>
          <h4
            className="heading-title"
            style={
              isMobile
                ? {  }
                : {}
            }
          >
            WHY CHOOSE CHEMIST FOR ALL?
          </h4>
          <div className="why-choose-content">
          <p>
            At Chemist For All, we source our medicines exclusively from
            trusted and certified pharmaceutical manufacturers in India —
            companies with a strong reputation for quality, safety, and
            compliance.
          </p>
          <div className="row">
            <div className="col-md-6">
              <ul>
                <li>
                  <a href="/about">High-Quality Generic Medicines</a>
                </li>
                <li>
                  <a href="/about">Wide Range of Categories</a>
                </li>
                <li>
                  <a href="/about">Prescription & OTC Products</a>
                </li>
              </ul>
            </div>
            <div className="col-md-6">
              <ul>
                <li>
                  <a href="/about">
                    Nationwide Delivery in the USA, Australia, and the UK
                  </a>
                </li>
                <li>
                  <a href="/about">Secure Ordering</a>
                </li>
                <li>
                  <a href="/about">Affordable Pricing & Bulk Discounts</a>
                </li>
              </ul>
            </div>
          </div>
          <div style={{ marginTop: 20 }}>
            <a
              href="/about"
              style={{
                backgroundColor: "#064ACB",
                color: "white",
                border: "none",
                borderRadius: 10,
                padding: 8,
              }}
            >
              Read More
            </a>
          </div>
          </div>
        </div>
      </div>
    </section>
  );

}